import { ReactNode, useState } from 'react';

import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/new/components/shadcn/dialog';
import { Input } from '@/new/components/shadcn/input';

interface TypedNameDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  confirmationName: string;
  inputPlaceholder: string;
  confirmLabel: string;
  isDeleting: boolean;
  onConfirm: () => void;
  children: ReactNode;
}

export function TypedNameDeleteDialog({
  open,
  onOpenChange,
  title,
  confirmationName,
  inputPlaceholder,
  confirmLabel,
  isDeleting,
  onConfirm,
  children,
}: TypedNameDeleteDialogProps) {
  const [confirmationText, setConfirmationText] = useState('');

  const handleOpenChange = (newOpen: boolean) => {
    if (!newOpen) setConfirmationText('');
    onOpenChange(newOpen);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent onClick={(event) => event.stopPropagation()}>
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--alert-triangle text-red-500" />
            {title}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {children}
          <div>
            <p className="mb-2 text-sm text-gray-600">
              To confirm, type <span className="font-semibold text-gray-900">{confirmationName}</span> below:
            </p>
            <Input
              value={confirmationText}
              onChange={(event) => setConfirmationText(event.target.value)}
              placeholder={inputPlaceholder}
              className="w-full"
              onClick={(event) => event.stopPropagation()}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="default" onClick={() => handleOpenChange(false)} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={confirmationText !== confirmationName || isDeleting}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
